import { commonSemanticActionLabels } from "./common-actions";

export const platformAdminValues = {
  semanticActions: {
    authorize: "Authorize",
    viewBindings: "Permission Bindings",
    viewCatalog: "Role Catalog",
    viewSnapshot: "Member Snapshot",
    manageCredentials: "Credentials",
    openDirectorWorkspace: "Open Director Workspace",
    openJudgeWorkspace: "Open Judge Workspace",
    openReviewWorkspace: "Open Review Workspace",
    generate: commonSemanticActionLabels.generate,
    configure: commonSemanticActionLabels.configure,
    commit: commonSemanticActionLabels.commit,
    rejudge: "Rejudge",
    instantiate: "Instantiate",
    compare: commonSemanticActionLabels.compare,
    resetPassword: commonSemanticActionLabels.resetPassword,
    unlock: commonSemanticActionLabels.unlock,
    lock: commonSemanticActionLabels.lock,
    impersonate: "Impersonate",
    kickout: "Kick Out",
    customFields: "Custom Fields",
    openConsole: "Open Console",
    openVnc: "Open VNC",
    extend: commonSemanticActionLabels.extend,
    destroy: commonSemanticActionLabels.destroy,
    viewTask: "View Task",
    heartbeat: "Heartbeat Snapshot",
    adoptVm: "Adopt VM",
    releaseVm: "Release VM",
  },
} as const;
